import React from "react";
import { Link } from "react-router-dom";
import Layout from "@/components/Layout";
import Disclaimer from "@/components/Disclaimer";
import { Button } from "@/components/ui/button";
import { Mail, ArrowRight, HelpCircle } from "lucide-react";

export default function Contact() {
  return (
    <Layout>
      <section className="max-w-4xl mx-auto px-6 py-16" data-testid="contact-page">
        <div className="mb-10">
          <div className="text-[10px] uppercase tracking-[0.24em] font-bold text-[var(--rg-sage)] mb-3">Support</div>
          <h1 className="font-heading font-extrabold text-4xl sm:text-5xl text-[var(--rg-text-strong)] mb-4">Get in Touch</h1>
          <p className="text-[var(--rg-text)] text-base">We are a small team and read every message personally.</p>
        </div>

        <div className="grid md:grid-cols-2 gap-6 mb-8">
          {/* LEFT — Email Support */}
          <div className="rounded-lg border border-[var(--rg-border)] bg-[var(--rg-surface)] p-6" data-testid="contact-email-section">
            <Mail className="w-6 h-6 text-[var(--rg-sage)] mb-3" />
            <h2 className="font-heading font-bold text-xl text-[var(--rg-text-strong)] mb-2">Email Support</h2>
            <p className="text-sm text-[var(--rg-text)] mb-3">
              Send us a message and we will respond within 48 hours on business days.
            </p>
            <a
              href="mailto:support@getregulens.com"
              className="inline-block text-[var(--rg-sage)] hover:underline font-mono text-sm"
              data-testid="contact-email-link"
            >
              support@getregulens.com
            </a>
            <p className="text-xs text-[var(--rg-muted)] mt-3">
              For billing questions include your account email.
            </p>
          </div>

          {/* RIGHT — Before you write */}
          <div className="rounded-lg border border-[var(--rg-border)] bg-[var(--rg-surface)] p-6" data-testid="contact-faq-section">
            <HelpCircle className="w-6 h-6 text-[var(--rg-sage)] mb-3" />
            <h2 className="font-heading font-bold text-xl text-[var(--rg-text-strong)] mb-2">Before you write</h2>
            <p className="text-sm text-[var(--rg-text)] mb-4">Most questions are answered in our FAQ.</p>
            <Link to="/faq">
              <Button className="bg-[var(--rg-sage)] text-[var(--rg-on-sage)] hover:bg-[var(--rg-sage-hover)] font-semibold" data-testid="contact-view-faq">
                View FAQ <ArrowRight className="w-4 h-4 ml-2" />
              </Button>
            </Link>
          </div>
        </div>

        <div className="rounded-md border border-[var(--rg-sage)] bg-[var(--rg-sage)]/10 p-4 mb-10 text-sm text-[var(--rg-text)] leading-relaxed" data-testid="contact-response-notice">
          <span className="font-bold text-[var(--rg-sage)] uppercase tracking-[0.16em] text-[10px] mr-2">Response times</span>
          Solo, Growth, Professional, and Agency plan users receive priority support. Free tier
          support response time is 48&ndash;72 hours.
        </div>

        <Disclaimer />
      </section>
    </Layout>
  );
}
